import React from 'react';
import { FollowOrganizerProps, OrganizerPanelListingsProps } from '../../types';
import ContactOrganizerRoot from '../ContactOrganizer/ContactOrganizerRoot';
import { FollowOrganizerWidget } from '../FollowOrganizer/FollowOrganizerRoot';
import { dynaMount } from '../utils/mountComponent';
import OrganizerPanelListings from './OrganizerPanelListings';

const ORGANIZER_PANEL_LISTINGS_ROOT_ID = 'listings-root__organizer-panel';
const FOLLOW_ORGANIZER_ORG_PANEL_ID =
    'listings-root__follow-organizer_org-panel';

const OrganizerPanelListingsMount = (
    props: OrganizerPanelListingsProps & FollowOrganizerProps,
) =>
    dynaMount(
        {
            Component: OrganizerPanelListings,
            containerId: ORGANIZER_PANEL_LISTINGS_ROOT_ID,
        },
        props,
    );

const FollowOrganizerOrgPanel = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_ORG_PANEL_ID,
        },
        props,
    );

const OrganizerPanelListingsRoot = (
    props: OrganizerPanelListingsProps & FollowOrganizerProps,
): JSX.Element | null => {
    const {
        gaCategory,
        gaSettings,
        isAuthenticated,
        isGDPRCountry,
        organizerId,
        organizerData,
        organizers,
        userId,
    } = props;
    return props.enableOrganizerPanelComponentOnListings ? (
        <OrganizerPanelListingsMount {...props} />
    ) : (
        <>
            <FollowOrganizerOrgPanel
                gaCategory={gaCategory}
                gaSettings={gaSettings}
                isAuthenticated={isAuthenticated}
                isGDPRCountry={isGDPRCountry}
                organizerId={organizerId}
                organizerData={organizerData}
                organizers={organizers}
                userId={userId}
            />
            <ContactOrganizerRoot {...props} />
        </>
    );
};

export default OrganizerPanelListingsRoot;
